import { templates } from "@/constants";
import { Flex, Typography } from "antd";
import { useState } from "react";
import { useLocation } from "react-router-dom";

import FormChristmas from "./FormTemplates/Christmas";
import FormTet from "./FormTemplates/Tet";
import FormProfile from "./FormTemplates/Profile";
import FormPostcard from "./FormTemplates/Postcard";
import FormQuoteOfTheDay from "./FormTemplates/QuoTeOfTheDay";
import FormPet from "./FormTemplates/Pet";
import FormWebsite from "./FormTemplates/Website";

import type { ICusTemplate, ITemplateType } from "@/store/interface/template";

export default function HomePage() {
  const location = useLocation();
  const editingTemplate = location.state?.template as ICusTemplate | undefined;

  const [selectedTemp, setSelectedTemp] = useState<ITemplateType | null>(
    editingTemplate?.type ?? null
  );

  const renderForm = () => {
    switch (selectedTemp) {
      case "christmas":
        return <FormChristmas initialData={editingTemplate} />;
      case "tet":
        return <FormTet initialData={editingTemplate} />;
      case "profile":
        return <FormProfile initialData={editingTemplate} />;
      case "postcard":
        return <FormPostcard initialData={editingTemplate} />;
      case "quote_of_the_day":
        return <FormQuoteOfTheDay initialData={editingTemplate} />;
      case "pet":
        return <FormPet initialData={editingTemplate} />;
      case "website":
        return <FormWebsite initialData={editingTemplate} />;
      default:
        return <></>;
    }
  };

  return (
    <section className="container">
      {!selectedTemp ? (
        <>
          <Typography.Title level={4}>Chọn mục đích sử dụng sản phẩm</Typography.Title>
          <Flex vertical gap={12}>
            {templates.map((tem, index) => (
              <div key={index}>
                <div
                  className="w-full p-3 border border-[#949494] rounded-xl flex gap-3"
                  onClick={() => setSelectedTemp(tem.key)}
                >
                  <img src={tem.icon} alt={"icon" + tem.icon} />
                  <div>
                    <Typography.Title level={5} className="mb-1">
                      {tem.name}
                    </Typography.Title>
                    <Typography.Text>{tem.description}</Typography.Text>
                  </div>
                </div>
              </div>
            ))}
          </Flex>
        </>
      ) : (
        renderForm()
      )}
    </section>
  );
}
